import {
  usePortalNotificationsMarkReadMutation,
  usePortalNotificationsQuery,
} from "@dashboard/graphql";
import { Box, Button, Text } from "@saleor/macaw-ui-next";
import { useEffect } from "react";
import { useIntl } from "react-intl";

import { Page, Section } from "../components";
import { portalMessages as m } from "../messages";
import { formatDateTime } from "../utils";

export const Notifications = () => {
  const intl = useIntl();
  const { data, refetch } = usePortalNotificationsQuery({ fetchPolicy: "cache-and-network" });
  const [markRead] = usePortalNotificationsMarkReadMutation({ onCompleted: () => refetch() });
  const unread = (data?.myNotifications ?? []).filter(n => !n.readAt);

  // Opening the list marks everything read (after it is shown once).
  useEffect(() => {
    if (unread.length) {
      const timer = window.setTimeout(() => markRead({ variables: {} }), 1500);

      return () => window.clearTimeout(timer);
    }
  }, [unread.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Page>
      <Section title={intl.formatMessage(m.notifications)}>
        {(data?.myNotifications ?? []).length === 0 && (
          <Text size={2} color="default2">
            {intl.formatMessage(m.noAlerts)}
          </Text>
        )}
        {data?.myNotifications.map(item => (
          <Box
            key={item.id}
            display="flex"
            flexDirection="column"
            gap={1}
            paddingY={2}
            borderBottomWidth={1}
            borderBottomStyle="solid"
            borderColor="default1"
          >
            <Text size={3} fontWeight={item.readAt ? undefined : "bold"}>
              {item.subject}
            </Text>
            {item.body && (
              <Text size={2} __whiteSpace="pre-wrap">
                {item.body}
              </Text>
            )}
            <Text size={1} color="default2">
              {formatDateTime(item.createdAt)}
            </Text>
          </Box>
        ))}
        {unread.length > 0 && (
          <Box>
            <Button size="small" variant="secondary" onClick={() => markRead({ variables: {} })}>
              {intl.formatMessage(m.markAllRead)}
            </Button>
          </Box>
        )}
      </Section>
    </Page>
  );
};
